import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Coins, Trophy, Crown } from "lucide-react";

export const ArtistInvestorsTab = ({ topInvestors, totalInvested }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      key="investors"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className="space-y-4"
    >
      {topInvestors.length === 0 ? (
        <div className="text-center py-12">
          <Coins className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Aucun investisseur pour le moment</p>
          <p className="text-xs text-muted-foreground mt-1">Soyez le premier a miser !</p>
        </div>
      ) : (
        <div className="bg-card border border-border rounded-3xl p-5 shadow-sm" data-testid="top-investors">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-heading font-bold text-sm text-card-foreground flex items-center gap-2">
              <Trophy className="w-4 h-4 text-yellow-500" />
              Top Miseurs
            </h3>
            <span className="text-xs text-muted-foreground font-mono-credits">
              {totalInvested.toLocaleString()} credits
            </span>
          </div>
          <div className="space-y-2">
            {topInvestors.map((inv, idx) => (
              <motion.div
                key={inv.user_id}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: idx * 0.05 }}
                className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-muted transition-colors"
                data-testid={`investor-${inv.user_id}`}
              >
                <div className="w-6 text-center shrink-0">
                  {idx === 0 ? (
                    <Crown className="w-5 h-5 text-yellow-500 mx-auto" />
                  ) : idx === 1 ? (
                    <Crown className="w-4 h-4 text-gray-400 mx-auto" />
                  ) : idx === 2 ? (
                    <Crown className="w-4 h-4 text-amber-600 mx-auto" />
                  ) : (
                    <span className="text-xs font-mono-credits text-muted-foreground font-bold">{idx + 1}</span>
                  )}
                </div>
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#FF6B35] to-[#FF8FA3] flex items-center justify-center shrink-0 overflow-hidden">
                  {inv.avatar_url ? (
                    <img src={inv.avatar_url} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-white text-xs font-bold">
                      {(inv.pseudo || "?")[0].toUpperCase()}
                    </span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <button
                    onClick={() => navigate(`/user/${inv.user_id}`)}
                    className="font-heading font-semibold text-sm text-card-foreground truncate hover:text-[#FF6B35] transition-colors"
                  >
                    {inv.pseudo}
                  </button>
                  <p className="text-[10px] text-muted-foreground">{inv.bet_count} mise{inv.bet_count > 1 ? "s" : ""}</p>
                </div>
                <span className="font-mono-credits font-bold text-sm text-[#FF6B35] shrink-0">
                  {inv.total_amount.toLocaleString()}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      )}
    </motion.div>
  );
};
